import { reactive } from 'vue'

// types
import { PaginationStateT, SetPaginationConfigT } from '@/core/types/pagination.types'

// classes
import { Pagination } from '@/core/classes/Pagination.class'

export default function () {
    const pagination_state: PaginationStateT = reactive(new Pagination({}))

    const setPagination = ({
        current_page,
        total_pages,
        limit,
        total_items,
    }: SetPaginationConfigT) => {
        if (current_page) pagination_state.current_page = current_page
        if (total_pages) pagination_state.total_pages = total_pages
        if (limit) pagination_state.limit = limit
        if (total_items) pagination_state.total_items = total_items
    }

    return { pagination_state, setPagination }
}
